import React from "react";
import { CardContent, Typography } from "@material-ui/core";
import TableResultWorking from "./TableResultWorking";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Grid, Card } from "@mui/material";

const ResultWorking = ({ report }) => {
  const { t } = useTranslation();
  return (
    <WrapperGrid item xs={12}>
      <Card
        sx={{
          "&:hover": {
            boxShadow:
              "rgb(0 0 0 / 16%) 0px 10px 36px 0px, rgb(0 0 0 / 6%) 0px 0px 0px 1px",
          },
          borderRadius: "20px",
          boxShadow: "unset",
        }}
      >
        <CardContent>
          <Typography variant="h6" component="div" style={{ fontSize: "15px" }}>
            {t("PROJECT_PAGE.REPORT.RESULT")}{" "}
          </Typography>
          <TableResultWorking report={report} />
        </CardContent>
      </Card>
    </WrapperGrid>
  );
};
const WrapperGrid = styled(Grid)`
  margin-top: 20px;
  padding: 16px 16px 0px 16px !important;
  // @media (max-width: 768px) {
  //   max-width: calc(100% - 12rem);
  //   overflow: auto;
  // }
`;
export default ResultWorking;
